module.exports = __webpack_public_path__ + "static/img/pic-cnt-active-5.8777ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/en/pic-cnt-active-5.png
// module id = Y8TV
// module chunks = 0